import { apiClient, postForm } from '@/shared/api/client';

export interface CommissionsQuery {
  bid_id: string;
  create_time_from: number | '';
  create_time_to: number | '';
}

/** Backend-agreed commission operation types (legacy comment: "по комментарию от бэка"). */
const COMMISSION_TYPE_IDS = [24, 38];

export function fetchCommissionsList(query: CommissionsQuery, page: number) {
  return postForm<Record<string, unknown>>('/bid/commission-report/list/', {
    ...query,
    page,
    type_ids: COMMISSION_TYPE_IDS,
  });
}

export async function exportCommissions(query: CommissionsQuery): Promise<Blob> {
  const { data } = await apiClient.get<Blob>('/bid/commission-report/export/', {
    params: Object.fromEntries(Object.entries(query).filter(([, value]) => value !== '')),
    responseType: 'blob',
  });
  return data;
}
